import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import "react-toastify/dist/ReactToastify.css";

export const Newest_Rent_Contract = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/newstRentContractRE`, config);
      dispatch({
        type: actions.NEWEST_CONTRACT_RENT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Newest_Sell_Contract = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/newEestSaleContractRE`, config);
      dispatch({
        type: actions.NEWEST_CONTRACT_SELL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Newest_Rent_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/NewestRentAvailablePropertyRE`,
        config
      );
      dispatch({
        type: actions.NEWEST_AVILABLE_RENT_PROPERTY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Newest_Sell_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/NewestSaleAvailablePropertyRE`,
        config
      );
      dispatch({
        type: actions.NEWEST_AVILABLE_SELL_PROPERTY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Newest_TakeMoney_Contract = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/NewestWaslRE`, config);
      dispatch({
        type: actions.NEWEST_TAKEMONEY_CONTRACT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Count_Avilable_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/CountAvailablePropertyRE`,
        config
      );
      dispatch({
        type: actions.COUNT_PROPERTY,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Count_Rent_Contract = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/countRentContractRE`, config);
      dispatch({
        type: actions.COUNT_RENT_CONTRACT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Count_Sell_Contract = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CountSaleContractRE`, config);
      dispatch({
        type: actions.COUNT_SELL_CONTRACT,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Total_sales_Money = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/totalProftRE`, config);
      dispatch({
        type: actions.TOTAL_MONEY_SALES,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_Sell_Rent_Chart = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/chartRentSaleRE`, config);
      dispatch({
        type: actions.SELL_RENT_CONTRACT_CHART,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_Sell_Rent_Chart_Vertical = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/chartSaleContractRE`, config);
      dispatch({
        type: actions.SELL_RENT_CONTRACT_CHART_VERTICAL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_Rent_Chart_Vertical = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/RentChartRE`, config);
      dispatch({
        type: actions.RENT_CONTRACT_CHART_VERTICAL,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Count_Required_Property = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CountRequiredPropertyRE`, config);
      dispatch({
        type: actions.COUNT_REQUIRED,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
